<template>
  <div>
    <TextEditor :on-change="onTextChange"
                :initial-value="initialValue"
                :on-link-added="searchMetadata"
                :users="users"
                :max-length="maxLength"
                :placeholder="placeholder"
                :editor-api="editorApi"
    />
    <LinkMetadataCover v-if="metadata" class="metadata-preview"
                       :title="metadata.title"
                       :description="metadata.description"
                       :image="metadata.image"
                       :url="metadata.url"
                       :remove-meta="removeMetadata"
    />
    <VLoadSpinner v-if="isLoading"
                  class="metadata-loading"
                  :is-loading="isLoading"
                  color="#454545"
    />
  </div>
</template>

<script>
import LinkMetadataCover from '../LinkMetadataCover'
import TextEditor from './TextEditor'
import VLoadSpinner from '../VLoadSpinner.vue'

export default {
  components: {
    TextEditor,
    LinkMetadataCover,
    VLoadSpinner
  },
  props: {
    onChange: {
      type: Function,
      default: () => {
      }
    },
    initialValue: {
      type: String,
      default: ''
    },
    initialMetadata: {
      type: Object,
      default: null
    },
    users: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    editorApi: {
      type: Function,
      default: () => {
      }
    }
  },
  watch: {
    initialValue(newValue) {
      this.html = newValue
    },
    initialMetadata(newValue) {
      this.metadata = newValue
    }
  },
  data() {
    return {
      html: this.initialValue,
      metadata: this.initialMetadata,
      isLoading: false
    }
  },
  methods: {
    onTextChange(html) {
      this.html = html
      this.handleChange()
    },
    removeMetadata() {
      this.metadata = null
      this.handleChange()
    },
    searchMetadata(url) {
      if (this.metadata == null) {
        this.isLoading = true
        this.$store.dispatch('searchMetadata', url).then(metadata => {
          this.metadata = metadata
          this.isLoading = false
          this.handleChange()
        }).catch(() => {
          this.isLoading = false
        })
      }
    },
    handleChange() {
      this.onChange(this.html, this.metadata)
    }
  }
}
</script>

<style lang="scss">
.metadata-preview {
  width: 550px;
  margin: 32px auto auto;
}

.metadata-loading {
  margin-top: 32px !important;
}
</style>
